import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchArtist, type ArtistProfile as ArtistProfileType } from '../api'
import { ArtworkCard } from '../components/ArtworkCard'

export function ArtistProfile() {
  const { slug } = useParams<{ slug: string }>()
  const [artist, setArtist] = useState<ArtistProfileType | null>(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!slug) return
    setLoading(true)
    fetchArtist(slug)
      .then(a => {
        if (a === null) setNotFound(true)
        else setArtist(a)
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [slug])

  if (loading) return <p className="state-loading container">Laster inn...</p>
  if (notFound) return <p className="state-empty container">Kunstner ikke funnet.</p>
  if (error || !artist) return <p className="state-error container">Noe gikk galt.</p>

  return (
    <main className="artist-profile container">
      <title>{artist.name} — Originalene</title>
      <meta name="description" content={artist.bio ? artist.bio.slice(0, 155) : `Se originalkunstverk av ${artist.name}. Kjøp direkte fra kunstneren på Originalene.`} />
      <div className="artist-header">
        <h1 className="artist-name">{artist.name}</h1>
        {artist.bio && <p className="artist-bio">{artist.bio}</p>}
      </div>

      <p className="section-heading">Works — {artist.artworks.length}</p>

      <div className="artwork-grid">
        {artist.artworks.map(a => <ArtworkCard key={a.id} artwork={a} />)}
        {artist.artworks.length === 0 && (
          <p className="state-empty" style={{ padding: '2rem 0', textAlign: 'left' }}>
            Ingen verk tilgjengelig.
          </p>
        )}
      </div>
    </main>
  )
}
